var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('empty'),_c('div',{staticClass:"backToHome fz85",on:{"click":_vm.handleBack}},[_vm._v(" "+_vm._s(_vm.$t('back'))),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }